import { NgModule } from '@angular/core';
import { TalentPoolsItemComponent } from '@modules/talent-pools-page/components/talent-pools-item/talent-pools-item.component';
import { MaterialModule } from '@material/material.module';
import { MojoCardModule } from 'mojo-card';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { DropdownMenuWithIconsModule } from '@shared/dropdown-menu-with-icons/dropdown-menu-with-icons.module';
import { RemoveTalentPoolModalComponent } from '../remove-talent-pool-modal/remove-talent-pool-modal';

@NgModule({
  imports: [
    RouterModule,
    MaterialModule,
    MojoCardModule,
    CommonModule,
    MatDialogModule,
    DropdownMenuWithIconsModule,
  ],
  declarations: [TalentPoolsItemComponent, RemoveTalentPoolModalComponent],
  exports: [TalentPoolsItemComponent],
})
export class TalentPoolsItemModule {}
